import hh from 'hyperscript-helpers';
import { h } from 'virtual-dom';
import {
    showDetailMsg,
    downloadFileMsg,
    deleteReportMsg,
    editReportMsg,
    clearDeleteSuccessBannerMsg,
    loadLinkDetailMsg,
    deleteAreYouSureMsg,
    cancelDeleteMsg
} from "../Update";
import { getButton } from "./View";
import { showMap } from "./MapView";

const { div, iframe, h2, ul, li, nav, a, p, i, legend,
    label, input, pre, option, button, select, span,
    form, table, td, tr, th, tbody,thead } = hh(h);

function detailResultRow(dispatch, result) {
    return table( { className: 'center w-100' }, tbody( {}, [
            render(result.rapportId, 'Rapport ID'),
            render(result.titel, 'Titel'),
            render(result.korttitel, 'Korttitel'),
            render(result.undertitel1, 'Undertitel'),
            render(result.noegleord, 'Nøgleord'),
            render(result.miljocenter, 'Miljøcenter'),
            render(result.forfattere, 'Forfattere'),
            render(result.udgivelsesdato, 'Udgivelsesdato'),
            render(result.antalsider, 'Antal sider'),
            render(result.kommentarer, 'Kommentarer'),
            render(result.kommentarer2, 'Kommentarer 2'),
            render(result.sprog, 'Sprog'),
            render(result.kommuneNavn, 'Kommune'),
            render(result.amt, 'Amt'),
            render(result.amtjournalnr, 'Amt journalnr.'),
            render(result.amtref, 'Amt ref.nr'),
            render(result.raadgiver, 'Rådgiver'),
            render(result.raadgiver_sagsnr, 'Rådgiver sagsnr.'),
            render(result.rekvirent, 'Rekvirent'),
            render(result.lovgrundlag, 'Lovgrundlag'),
            render(result.formaal, 'Formål'),
            render(result.metode, 'Rapportmetoder'),
            render(result.indlaest, 'Indlæst'),
            render(result.rettet, 'Rettet'),
        ]));
}

function renderFilesAndLinks(dispatch, model) {
    if (!model.detail.queryResult)
        return '';

    return div( {}, [
        renderFiles(dispatch, model.detail.queryResult.files),
        renderLinks(dispatch, model),
        renderGeoRefs(model.detail.queryResult.rapportId, model.detail.queryResult.geoRefs)
    ]);
}
function renderFiles(dispatch, files) {
    if (!files)
        return '';

    const addedRenderedList = [];
    files.forEach( function render(file, index) {
        addedRenderedList.push(
            li( { className: 'bt b--black-30' },
                div( { className: 'w-100 mb1'}, [
                    a( { className: 'f6 link dim dark-blue dib pointer', onclick: () => dispatch(downloadFileMsg(file.id, file.filNavn))}, file.filNavn),
                    span( { className: 'ml2 f7' }, "(" + file.size + ")")
                ])
            )
        );
    }) ;
    return div( { className: '' }, [
        p( { className: 'pl2'}, 'Filer' ),
        ul( { className: 'list'}, [ ...addedRenderedList ] )
    ]);
}
function renderLinks(dispatch, model) {
    const links = model.detail.queryResult.links;
    if (!links || links.length === 0) return '';

    const addedRenderedList = [];
    links.forEach( function render(link, index) {
        const url = LINKS[link.type] + link.link;
        addedRenderedList.push(
            li( { className: 'bt b--black-30' },
                div( { className: 'w-100 mb1'}, [
                    span( { className: 'mr2 f7' }, "(" + link.type + ")"),
                    link.prettyLink ? a( { className: 'f6 link dim dark-blue dib pointer', href: url, target: '_blank' }, link.prettyLink) : a( { className: 'f6 link dim dark-blue dib pointer', href: url, target: '_blank' }, link.link)
                ])
            )
        );
    }) ;

    return div( { className: '' }, [
        p( { className: 'pl2'}, 'Link'),
        getErrorMsg(model.detail.linkError),
        ul( { className: 'list'}, [ ...addedRenderedList ] )
    ]);
}
function getErrorMsg(errorMsg) {
    if (!errorMsg) return '';

    return p({ className: 'pl4 red' }, 'Fejl ved indlæsning af links. (' + errorMsg + ')');
}
const LINKS = {
    BORING: 'https://data.geus.dk/JupiterWWW/borerapport.jsp?borid=', // https://data.geus.dk/JupiterWWW/borerapport.jsp?dgunr=',
    MODEL: '',
    GEOFYSISK: 'https://gerda.geus.dk/gerdawww/details.html?project='
};
function render(value, label) {
    return value ?
            tr({ className : 'striped--light-gray' }, [
                td({ className: 'pa2 tl'}, label),
                td({ className: 'pa2 tl' }, value),
            ])
            : '' ;
}
function renderWithPre(value, label) {
    return value ?
            tr({ className : 'striped--light-gray' }, [
                td({ className: 'pa2 tl'}, label),
                td({ className: 'pa2 tl pre' }, value),
            ])
            : '' ;
}
function makeLink(value) {
    return a( { className: 'f6 link dim dark-blue db pointer', href: `${value}` }, value);
}
function renderGeoRefs(rapportId, geoReferences) {
    if (!geoReferences || !rapportId) return '';

    return mapView(geoReferences, rapportId);
}

function mapView(geoReferences, rapportId) {
    const wkts = [];
    geoReferences.forEach(g => {
        if (g.geoReferenceNumber && g.wktGeometry) wkts.push(g.wktGeometry);
    });
    if (wkts.length == 0) return '';

    setTimeout(function() {
        setTargetOnMapModel(wkts, rapportId);
    }, 650);

    return div({ className: 'mt2', style: 'height: 400px', id: 'detailMap' }, '');
}
let detailMapModel;
function setTargetOnMapModel(wktGeometry, rapportId) {
    if (document.getElementById('detailMap') && document.getElementById('detailMap').innerHTML !== "" && detailMapModel) {
        return;
    }

    detailMapModel = showMap(wktGeometry, rapportId);
    detailMapModel.setTarget('detailMap');
}

function reportView(dispatch, model) {
    if (model.detail.deleted) {
            setTimeout(function() {
                dispatch(clearDeleteSuccessBannerMsg);
            }, 3000);
            return div({
                id: 'result',
                className: 'modal baskerville'
            }, div({className: 'modal-content b--green'}, [
                    div( { className: 'bg-green white pt2 pb2 tc' } , i( { className: 'fa fa-check-circle-o fa-5x'} ) ),
                    div( { className: 'bg-near-white black-80' } , [
                        p( { className: 'f2 tc mt0 pt3' }, 'Udført!'),
                        p( { className: 'f4 tc mb0 pb4' }, 'Rapporten er slettet.'),
                    ]),
               ])
            );
    }

    if (!model.detail.queryResult)
        return div({}, 'EMPTY');

    return detailResultRow(dispatch, model.detail.queryResult);
}
function deleteReportLink(dispatch, model) {
    if ( model.detail.queryResult.owner ) {
        return getButton('Slet rapport', ' fr ml1', false, dispatch, deleteAreYouSureMsg); //deleteReportMsg);
    }
    return '';
}
function editReportLink(dispatch, model) {
    if ( model.detail.queryResult.owner ) {
        return getButton('Redigér rapport', ' fr', false, dispatch, editReportMsg);
    }
    return '';
}
function loadButton(dispatch, reportId) {
    setTimeout(function() {
        dispatch(showDetailMsg(reportId));
    }, 100);
    return div({ className: 'mv3 f4 tc i black-50' }, ('Henter rapport ' + reportId + '...'));
}
function loadLinks(dispatch, model) {
    const boringer = model.detail.queryResult.links.filter(link => link.type === 'BORING');
    if (!boringer.length) return false;

    setTimeout(function() {
        dispatch(loadLinkDetailMsg);
    }, 50);

    return true;
}

function deleteAreYouSure(dispatch, model) {
    if (!model.deleteForSure) return '';

    return div({
            className: 'modal '
        }, div({className: 'modal-content b--red'}, [
            div( { className: 'bg-red white pt2 pb2 tc' } , i( { className: 'fa fa-exclamation fa-5x'} ) ),
            div( { className: 'bg-near-white black-80 tc pv2' } , [
                p({ className: 'f4 mt0' }, 'Er du sikker på at du vil slette rapporten ?'),
                button({ className: 'ph3-ns ph2 pv2-ns pv1 input-reset ba br2 white b--red bg-red hover-bg-dark-red pointer f5-ns f6', type: 'button', onclick: e => dispatch(deleteReportMsg) }, 'Ja'),
                button({ className: 'ml3 ph3-ns ph2 pv2-ns pv1 input-reset ba br2 black b--black bg-white hover-bg-light-gray pointer f5-ns f6', type: 'button', onclick: e => dispatch(cancelDeleteMsg) }, 'Nej')
            ]),
        ])
    );

}

export function detailView(dispatch, model) {
    if (model.state === 'detail' && model.detail.loadReportId) {
        return div({ className: 'mv2 tc i black-50' }, loadButton(dispatch, model.detail.loadReportId)); //, pre( { className: 'mw-50' },  JSON.stringify(model, null, 2)) ]);
    }
    if (model.state === 'detail' && model.detail.loadLinks && loadLinks(dispatch, model)) {
        return div({ className: 'mv3 f4 tc i black-50' }, ('Henter links ...'));
    }
    if (model.state !== 'detail' || !model.detail.selectedRapportId)
        return div({ className: 'mv2 tc i black-50' }, [ 'Ingen rapport at vise...']); //, pre( { className: 'mw-50' },  JSON.stringify(model, null, 2)) ]);

    return div({ className: 'center mw7-ns f6' }, [
        div ( { className: 'db' } , [
            legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Grundvandsrapport ' + model.detail.selectedRapportId),
            deleteReportLink(dispatch, model),
            editReportLink(dispatch, model),
            deleteAreYouSure(dispatch, model),
        ]),
        reportView(dispatch, model),
        renderFilesAndLinks(dispatch, model),
        // pre( { className: 'mw-50' },  JSON.stringify(model, null, 2)),
    ]);
}